var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-controls"},[_c('div',{staticClass:"right-control"},[_c('profile-avatar-button')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }